import { useEffect } from 'react'
import { usePayment } from '../MembershipModal/context/payment'
import {
  BundleBannerImage,
  BundleBannerWrapper,
  Dots
} from './BundleBanners.styles'
import {
  CarouselProvider,
  Slide,
  Slider,
  Dot,
  DotGroup
} from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { useDispatch } from 'react-redux'
import {
  setPreselectPackage,
  setShowPurchaseCoins
} from '../../redux/designerReducers/designerReducer'

export const BundleBanners = () => {
  const { bundlesList = [], getProducts, selectPackage } = usePayment() || {}
  const dispatch = useDispatch()

  useEffect(() => {
    if (getProducts) getProducts()
  }, [])

  return (
    <BundleBannerWrapper>
      <CarouselProvider
        totalSlides={bundlesList.length}
        infinite={true}
        naturalSlideWidth={289}
        naturalSlideHeight={90}
        visibleSlides={1}
        interval={3000}
        isPlaying={true}
      >
        <Slider>
          {bundlesList.map((bundle, index) => {
            return (
              <Slide key={bundle.objectId} index={index}>
                <BundleBannerImage
                  onClick={() => {
                    dispatch(
                      setPreselectPackage({ ...bundle, closeMode: 'close' })
                    )
                    dispatch(setShowPurchaseCoins(true))
                  }}
                  src={bundle.imageUrl}
                  key={index}
                />
              </Slide>
            )
          })}
        </Slider>
        <Dots />
      </CarouselProvider>
    </BundleBannerWrapper>
  )
}
